import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import {hidePopUp, showPopUp} from '@/actions/modalActions';
import {showAlert} from '@/actions/setupActions';
import axiosMethods from '@/api/apiManager';
import {postCheckVersionUpdateSW} from '@/api/updateApi';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventCheckUpdateSystem} from '@/constants/pubSubEnum';
import SystemUpdateProgress from '@/hooks/useSystemUpdateProgress';
import {setSessionStorage, getSessionStorage, removeSessionStorage} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';
import apiObserver from '@/observers/apiObserver';
import {eventBusObject} from '@/observers/eventBus';

// eslint-disable-next-line import/no-cycle
import UpdateSystem, {EventUpdateSystem} from '../updateSystem/UpdateSystem';

@connect(() => ({}))
class UpdateSoftwareService extends React.Component {
  constructor(props) {
    super(props);
    // Initiate state for this component
    this.state = {
      availabeUpdate: [],
      indexDownload: 0,
      IsFromHome: undefined,
    };
    this._bus = eventBusObject();

    this.checkUpdate = this.checkUpdate.bind(this);
    this.cancelEvents = this.cancelEvents.bind(this);
  }

  componentDidMount() {
    this.eventCheckUpdate = this._bus.subscribe(EventCheckUpdateSystem.CheckingVersionUpdate, (param) =>
      this.checkUpdate(param),
    );
  }

  componentWillUnmount() {
    this.eventCheckUpdate.unsubscribe();
  }

  cancelEvents = () => {
    const {dispatch} = this.props;
    dispatch(loadingActions.showLoading(false));
    dispatch(modalActions.hidePopUp());
  };

  // ---------------------------------------- CheckSoftwareVersion & checkUpdate ----------------------------
  checkUpdate = (params) => {
    if (params.value !== APPDATA.INFO_AND_SUPPORT_ADDRESS) return;

    const {dispatch} = this.props;

    removeSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);

    this.setState({
      IsFromHome: params.IsFromHome,
    });
    if (params.IsFromHome === undefined) {
      dispatch(
        loadingActions.updateLoading({
          showLoading: true,
          loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.CHECK_INTERNET_CONNECTION,

          // note: this cancelation callback for this loading didn't have a requirement
          // loadingClickEvent: this.tapScreenDownloadCheckVersion,
        }),
      );
    }
    // const param = {};
    const passingValue = {};
    this._isCheckVersionCanceled = false;

    postCheckVersionUpdateSW(true)
      .then((response) => {
        if (response.status === 200) {
          this.successCheckSoftwareVersion(response, passingValue);
        } else {
          apiObserver.notify.errorResponseHandler(response);
          this.errorCheckSoftwareVersion(response, passingValue);
        }
      })
      .catch((error) => {
        dispatch(loadingActions.showLoading(false));
        dispatch(modalActions.hidePopUp());
        if (!axiosMethods.isCancel(error)) {
          // apiObserver.notify.errorHandler(error);
          this.failedCheckSoftwareVersion(error.response, passingValue);
        }
      });
  };

  successCheckSoftwareVersion = (response) => {
    console.log({response, type: response.data.type});
    const {dispatch} = this.props;
    const {IsFromHome} = this.state;
    if (this._isCheckVersionCanceled === true) return;
    const availabeUpdate = [];
    switch (response.data.type) {
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[
                APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT
              ],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      default:
        if (response.data.IsUpdateAvailable) {
          availabeUpdate.push(APPDATA.ENUM.UPDATE_TYPE.SOFTWARE);
        }
        this.setState({
          availabeUpdate,
          indexDownload: 0,
        });

        if (availabeUpdate.length > 0) {
          setSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM, availabeUpdate);
          const popUpButton = [
            {
              id: APPDATA.YES,
              isPrimaryButton: true,
              onClick: this.onClickUpdateAvailable,
              label: APPDATA.YES,
            },
            {
              id: APPDATA.NO,
              isPrimaryButton: false,
              onClick: this.onClickUpdateAvailable,
              label: APPDATA.NO,
            },
          ];
          let id = 0;
          const updateType = 'Software is';

          dispatch(
            showPopUp({
              popUpTitle: APPDATA.ONLINE_UPDATE,
              popUpText: (
                <>
                  {APPDATA.MESSAGES.SOFTWARE_UPDATE.NEW_VERSION_FOUND.replace('{UPDATE_TYPE}', updateType)
                    .split('\n')
                    .map((item) => {
                      id += 1;
                      const showWhatsNewLink = item.includes("{What's-New-Page}");
                      const whatsNewLink = showWhatsNewLink ? (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a onClick={this.goToWhatsNew}>What&apos;s New Page.</a>
                      ) : (
                        ''
                      );
                      return (
                        <span key={id}>
                          {item.replace("{What's-New-Page}.", '')}
                          {showWhatsNewLink && whatsNewLink}
                          <br />
                        </span>
                      );
                    })}
                </>
              ),
              popUpButton,
            }),
          );
        } else {
          const popUpButton = [
            {
              id: APPDATA.OK,
              isPrimaryButton: true,
              onClick: this.onClickNoUpdate,
              label: APPDATA.OK,
            },
          ];
          if (IsFromHome === undefined) {
            dispatch(
              showPopUp({
                popUpTitle: APPDATA.ONLINE_UPDATE,
                popUpText: APPDATA.MESSAGES.SOFTWARE_UPDATE.NO_NEW_VERSION,
                popUpButton,
              }),
            );
          }
        }
        break;
    }
    dispatch(loadingActions.showLoading(false));
  };

  failedCheckSoftwareVersion = (response) => {
    const {dispatch} = this.props;
    const {IsFromHome} = this.state;
    if (IsFromHome === undefined) {
      dispatch(loadingActions.showLoading(false));
    }
    consoleLog('FAILED GET SOFTWARE VERSION', response);
    switch (response.data.type) {
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.INVALID_TIME:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.INVALID_TIME],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[
                APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT
              ],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      default:
        break;
    }
  };

  errorCheckSoftwareVersion = (error) => {
    const {dispatch} = this.props;
    const {IsFromHome} = this.state;
    if (IsFromHome === undefined) {
      dispatch(loadingActions.showLoading(false));
    }
    consoleLog('ERROR GET SOFTWARE VERSION', {error, response: error.response});
    switch (error.response.data.type) {
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[
                APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT
              ],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
        break;
      case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET:
        dispatch(
          showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_ONLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.NO_INTERNET],
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      default:
        break;
    }
  };

  goToWhatsNew = () => {
    const {dispatch} = this.props;
    dispatch(hidePopUp());
    window.location.href = APPDATA.RELEASE_NOTES_ADDRESS;
  };

  onClickNoUpdate = () => {
    const {dispatch} = this.props;
    dispatch(hidePopUp());
  };

  onClickUpdateAvailable = (e) => {
    const {dispatch} = this.props;
    const {availabeUpdate, indexDownload} = this.state;
    switch (e.currentTarget.id) {
      case APPDATA.YES: {
        const param = {
          [APPDATA.KEY.DownloadType]: availabeUpdate[indexDownload],
        };
        const passingVariabel = {
          [APPDATA.KEY.DownloadType]: availabeUpdate[indexDownload],
        };
        this.downloadAction(param, passingVariabel);
        break;
      }
      // call api update software
      case APPDATA.NO:
        break;
      default:
        break;
    }
    dispatch(hidePopUp());
  };

  downloadAction = () => {
    let UpdateType = [];
    UpdateType = getSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);
    this._bus.publish(EventUpdateSystem.DownloadBinaryUpdate, {UpdateType});
  };
  // ---------------------------------------- END CheckSoftwareVersion & checkUpdate ----------------------------

  render() {
    // return <React.Fragment></React.Fragment>;
    return (
      <>
        <SystemUpdateProgress />
        <UpdateSystem />
      </>
    );
  }
}

UpdateSoftwareService.propTypes = {
  dispatch: PropTypes.func,
};
UpdateSoftwareService.defaultProps = {
  dispatch: () => {},
};

export default connect()(UpdateSoftwareService);
